export default "__VITE_ASSET__2d36b1c2__"